import { useState } from "react";
import { isFlagEnabled } from "js/utilities";
import { RadioGroup } from "@headlessui/react";
import {
  stringFormattingToCurrency,
  stringFormatingToPascal,
} from "js/formatting";

const DeprecatedPanelTwo = ({
  panelTwoSelection,
  setPanelTwoSelection,
  register,
  setValue,
  setCurrentStep,
  selected,
  handleSubmit,
  dataSubmit,
  setIsDisabled,
}) => {
  const [checkboxState, setCheckboxState] = useState({
    amountDue: false,
    annualAmount: false,
    otherAmount: false,
  });

  const onSubmit = () => {
    // Number(a) < Number(minPayment) ? setCurrentStep(2) : setCurrentStep(3)
    handleSubmit(dataSubmit);
    if (
      isFlagEnabled("ENABLE_HIDE_CREDIT_CARD_SELECTION_ON_ONE_TIME_PAYMENT")
    ) {
      setIsDisabled(false);
    } else {
      setCurrentStep(3);
    }
  };

  return (
    <>
      {selected && (
        <div className="px-0 md:px-16">
          <form>
            <RadioGroup
              className="ui-form-card-row"
              name="panelOneSelection"
              value={panelTwoSelection}
              onChange={setPanelTwoSelection}
            >
              <RadioGroup.Option
                id="ID_paymentStep1Option1"
                className={({ checked }) =>
                  `${
                    checked && checkboxState.monthly
                      ? "ui-form-card selected"
                      : "ui-form-card"
                  }  `
                }
                {...register("amount")}
                tabIndex="0"
                aria-label="Select to pay this policy"
                aria-controls="ID_paymentStep2Options"
                aria-expanded="false"
                disabled={
                  parseFloat(selected?.modalPremiumAmountTotal) <= 0 ||
                  !selected?.modalPremiumAmountTotal
                }
                onClick={() => {
                  setCheckboxState({
                    monthly: true,
                    annualAmount: false,
                    otherAmount: false,
                  });
                  setValue("amount", selected?.modalPremiumAmountTotal ?? 0);
                  onSubmit();
                }}
                value="monthly"
              >
                {({ checked }) => (
                  <>
                    <RadioGroup.Label
                      className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                      as="p"
                    >
                      Amount Due
                    </RadioGroup.Label>
                    <RadioGroup.Label className="block text-black">
                      {selected?.modalPremiumAmountTotal
                        ? stringFormattingToCurrency(
                            selected?.modalPremiumAmountTotal
                          )
                        : "$0.00"}
                    </RadioGroup.Label>
                    <RadioGroup.Label className="text-xxs">
                      {stringFormatingToPascal(selected.billingMode)}
                    </RadioGroup.Label>
                    <div className="text-xxs font-semibold pr-8 group-hover:underline">
                      <div className="ui-form-card-checkbox">
                        <svg
                          className="ui-icon w-2 h-2 text-white hidden"
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-checkmark"></use>
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            </RadioGroup>
          </form>
        </div>
      )}
    </>
  );
};

export default DeprecatedPanelTwo;
